import React, { useEffect, useState } from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';

import {
  getAllUsersListByAnyRef,
  GetUsersByAnyRefParams,
} from 'services/parametersService';

export type UsersProps =SelectProps<any> & {
  statusprops?: string;
  userRole?: string;
  mgid?:string
  userid?:number
};
const UsersInput = (props: UsersProps) => {
  const [searchParams, setSearchParams] = useState<GetUsersByAnyRefParams>({
    email: '',
    locked: false,
    mgid: props.mgid ?? (localStorage.getItem('mgid') as any) ?? '',
    mobile: '',
    name: '',
    phone: '',
    status:props.statusprops?? 'ENABLED',
    surname: '',
    username: '',
    userrole: props.userRole ?? '',
    userid: props.userid ?? Number(localStorage.getItem('userid')) ?? undefined,
    useridmanager: undefined,
  });
  console.log(props.userRole)
  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      userrole: props.userRole ?? '',
      mgid: Number(props.mgid ?? prev.mgid) ?? undefined,
      status: props.statusprops ?? prev.status,
    }));
  }, [props.userRole, props.mgid, props.statusprops]);
  const { data } = useQuery(['getAllUsersListByAnyRef', searchParams], () =>
    getAllUsersListByAnyRef(searchParams).then((res) => res.list || [])
  );
  return (
    <Select autoClearSearchValue {...props} allowClear>
      {data?.map((user) => (
        <Select.Option value={user.id} key={user.id}>
          {user.surname + ' ' + user.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default UsersInput;
